import { render } from "./EditContactPopUp.vue?vue&type=template&id=a5b269f4&scoped=true"
import script from "./EditContactPopUp.vue?vue&type=script&lang=js"
export * from "./EditContactPopUp.vue?vue&type=script&lang=js"

import "./EditContactPopUp.vue?vue&type=style&index=0&id=a5b269f4&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b269f4"]])

export default __exports__